module.exports = __webpack_public_path__ + "img/data2.7ca40e95.png";